import React from 'react';

import {
  ButtonLink,
  ButtonHandle,
  styles,
} from './styled-components';

/**
 * @param {string} text - display text
 * @param {string} url - target for the link 
 * @param {enum: } buttonStyle - describe the form the button is displayed
 * @param {func} onClick - if there is no url provided bind a onClick Handle to the button
 */
const Button = ({ url, buttonStyle, onClick, children, animation }) => {
  return url 
    ? <ButtonLink buttonStyle={buttonStyle} href={url} animation={animation}>
      {children}
    </ButtonLink>
    : <ButtonHandle buttonStyle={buttonStyle} onClick={onClick} animation={animation}>
      {children}
    </ButtonHandle>;
}

Button.defaultProps = {
  url: 'http://google.com',
  buttonStyle: styles.BLACK,
  children: 'Lorem Ipsum',
  animation: true,
}

export default Button;